import {
  EAppGroupCommercial,
} from '@/types/app-type';
import {
  EUnitOfMeasurement,
  TUnitSymbolRequiresTranslation,
} from '@/types/unit-of-measurement.ts';

const AppGroupCommercial: Record<EAppGroupCommercial, string> = {
  [EAppGroupCommercial.QMULUS_ESSENTIAL]: 'QMULUS Essential',
  [EAppGroupCommercial.QMULUS_LITE]: 'QMULUS Lite',
  [EAppGroupCommercial.SETTINGS]: 'Settings',
  [EAppGroupCommercial.QMULUS_EXPERT]: 'QMULUS Expert',
  [EAppGroupCommercial.SIMULATORS]: 'Simulators',
  [EAppGroupCommercial.QMULUS_OPERATIONS]: 'QMULUS Operations',
  [EAppGroupCommercial.QMULUS_PERFORMANCE]: 'QMULUS Performance',
  [EAppGroupCommercial.QMULUS_AI]: 'QMULUS AI',
  [EAppGroupCommercial.QMULUS_ANALYTICS]: 'QMULUS Analytics',
  [EAppGroupCommercial.QMULUS_AUDIT]: 'QMULUS Audit',
  [EAppGroupCommercial.QMULUS_QUALITY]: 'QMULUS Quality',
  [EAppGroupCommercial.QMULUS_PLANNER]: 'QMULUS Planner',
  [EAppGroupCommercial.QMULUS_TOOLING_AND_GAUGE_MANAGER]: 'QMULUS Tooling and Gauge Manager',
  [EAppGroupCommercial.QMULUS_AUTOMATION]: 'QMULUS Automation',
};

const UnitOfMeasurementSymbol: Record<Exclude<EUnitOfMeasurement, TUnitSymbolRequiresTranslation>, string> = {
  [EUnitOfMeasurement.AMPERE]: 'A',
  [EUnitOfMeasurement.ATMOSPHERE]: 'atm',
  [EUnitOfMeasurement.BAR]: 'bar',
  [EUnitOfMeasurement.BAR_PER_MINUTE]: 'bar/min',
  [EUnitOfMeasurement.BRINELL_HARDNESS]: 'BHN',
  [EUnitOfMeasurement.BRINELL_HARDNESS_10_1500_10]: 'HB 10/1500/10',
  [EUnitOfMeasurement.BRINELL_HARDNESS_10_1500_15]: 'HB 10/1500/15',
  [EUnitOfMeasurement.BRINELL_HARDNESS_10_3000_10]: 'HB 10/3000/10',
  [EUnitOfMeasurement.BRINELL_HARDNESS_10_3000_15]: 'HB 10/3000/15',
  [EUnitOfMeasurement.BRINELL_HARDNESS_10_500_10]: 'HB 10/500/10',
  [EUnitOfMeasurement.BRINELL_HARDNESS_10_500_15]: 'HB 10/500/15',
  [EUnitOfMeasurement.BRINELL_HARDNESS_6_1500_10]: 'HB 6/1500/10"',
  [EUnitOfMeasurement.BRINELL_HARDNESS_6_1500_15]: 'HB 6/1500/15"',
  [EUnitOfMeasurement.BRINELL_HARDNESS_6_3000_10]: 'HB 6/3000/10"',
  [EUnitOfMeasurement.BRINELL_HARDNESS_6_3000_15]: 'HB 6/3000/15"',
  [EUnitOfMeasurement.BRINELL_HARDNESS_6_500_10]: 'HB 6/500/10"',
  [EUnitOfMeasurement.BRINELL_HARDNESS_6_500_15]: 'HB 6/500/15',
  [EUnitOfMeasurement.BTU]: 'BTU',
  [EUnitOfMeasurement.BTU_PER_HOUR]: 'BTU/h',
  [EUnitOfMeasurement.BTU_PER_MINUTE]: 'BTU/min',
  [EUnitOfMeasurement.CENTIMETRE_PER_MINUTE]: 'cm/min',
  [EUnitOfMeasurement.CENTIMETRE_PER_SECOND]: 'cm/s',
  [EUnitOfMeasurement.CUBIC_CENTIMETRE_PER_MINUTE]: 'cc/min',
  [EUnitOfMeasurement.CUBIC_FEET]: 'ft³',
  [EUnitOfMeasurement.CUBIC_FEET_PER_HOUR]: 'cfh',
  [EUnitOfMeasurement.CUBIC_FEET_PER_MINUTE]: 'cfm',
  [EUnitOfMeasurement.CUBIC_METRES]: 'm³',
  [EUnitOfMeasurement.CUBIC_METRE_PER_HOUR]: 'm³/h',
  [EUnitOfMeasurement.CUBIC_METRE_PER_MINUTE]: 'm³/min',
  [EUnitOfMeasurement.CUBIC_METRE_PER_SECOND]: 'm³/s',
  [EUnitOfMeasurement.DEGREES_CELSIUS]: '°C',
  [EUnitOfMeasurement.DEGREES_CELSIUS_PER_MINUTE]: 'K/min',
  [EUnitOfMeasurement.DEGREES_FAHRENHEIT]: '°F',
  [EUnitOfMeasurement.DEGREES_FAHRENHEIT_PER_MINUTE]: '°F/min',
  [EUnitOfMeasurement.DEGREES_KELVIN]: 'K',
  [EUnitOfMeasurement.DELTA_DEGREES_CELSIUS]: 'K',
  [EUnitOfMeasurement.DELTA_DEGREES_FAHRENHEIT]: 'Δ°F',
  [EUnitOfMeasurement.DELTA_DEGREES_KELVIN]: 'K',
  [EUnitOfMeasurement.FEET_OF_WATER_COLUMN]: 'ftH₂O',
  [EUnitOfMeasurement.FEET_PER_MINUTE]: 'ft/min',
  [EUnitOfMeasurement.FEET_PER_SECOND]: 'ft/s',
  [EUnitOfMeasurement.GALLONS_PER_HOUR]: 'gph',
  [EUnitOfMeasurement.GALLONS_PER_MINUTE]: 'gpm',
  [EUnitOfMeasurement.GRAM]: 'g',
  [EUnitOfMeasurement.GRAM_PER_SECOND]: 'g/s',
  [EUnitOfMeasurement.HECTO_PASCAL]: 'hPa',
  [EUnitOfMeasurement.HERTZ]: 'Hz',
  [EUnitOfMeasurement.HORSEPOWER]: 'hp',
  [EUnitOfMeasurement.INCH]: 'in',
  [EUnitOfMeasurement.INCH_OF_MERCURY]: 'inHg',
  [EUnitOfMeasurement.INCH_OF_WATER_COLUMN]: 'inH₂O',
  [EUnitOfMeasurement.INCH_PER_MINUTE]: 'in/min',
  [EUnitOfMeasurement.INCH_PER_SECOND]: 'in/s',
  [EUnitOfMeasurement.KILOGRAM]: 'kg',
  [EUnitOfMeasurement.KILOGRAM_PER_HOUR]: 'kg/h',
  [EUnitOfMeasurement.KILOGRAM_PER_MINUTE]: 'kg/min',
  [EUnitOfMeasurement.KILOGRAM_PER_SECOND]: 'kg/s',
  [EUnitOfMeasurement.KILOMETER]: 'km',
  [EUnitOfMeasurement.KILOVOLT]: 'kV',
  [EUnitOfMeasurement.KILOVOLT_AMPERE]: 'kVA',
  [EUnitOfMeasurement.KILOWATT]: 'kW',
  [EUnitOfMeasurement.KILOWATT_HOUR]: 'kWh',
  [EUnitOfMeasurement.KILO_PASCAL]: 'kPa',
  [EUnitOfMeasurement.KNOOP_HARDNESS]: 'HK',
  [EUnitOfMeasurement.KNOOP_HARDNESS_100]: 'HK 100',
  [EUnitOfMeasurement.KNOOP_HARDNESS_200]: 'HK 200',
  [EUnitOfMeasurement.KNOOP_HARDNESS_500]: 'HK 500',
  [EUnitOfMeasurement.KNOOP_HARDNESS_50]: 'HK 50',
  [EUnitOfMeasurement.LITRE]: 'l',
  [EUnitOfMeasurement.LITRE_PER_HOUR]: 'l/h',
  [EUnitOfMeasurement.LITRE_PER_MINUTE]: 'l/min',
  [EUnitOfMeasurement.MEGAWATT]: 'MW',
  [EUnitOfMeasurement.METRES_PER_MINUTE]: 'm/min',
  [EUnitOfMeasurement.METRES_PER_SECOND]: 'm/s',
  [EUnitOfMeasurement.METRE]: 'm',
  [EUnitOfMeasurement.MICROBAR]: 'μbar',
  [EUnitOfMeasurement.MICROBAR_PER_MINUTE]: 'μbar/min',
  [EUnitOfMeasurement.MICRON]: 'μm',
  [EUnitOfMeasurement.MICRON_HG_PER_HOUR]: 'μmHg/h',
  [EUnitOfMeasurement.MICRON_HG_PER_MINUTE]: 'micron (μmHg)/min',
  [EUnitOfMeasurement.MICRON_OF_MERCURY]: 'micron (μmHg)',
  [EUnitOfMeasurement.MILLIBAR]: 'mbar',
  [EUnitOfMeasurement.MILLIBAR_PER_MINUTE]: 'mbar/min',
  [EUnitOfMeasurement.MILLIGRAM]: 'mg',
  [EUnitOfMeasurement.MILLILITRE]: 'ml',
  [EUnitOfMeasurement.MILLILITRE_PER_MINUTE]: 'ml/min',
  [EUnitOfMeasurement.MILLIMETRE]: 'mm',
  [EUnitOfMeasurement.MILLIMETRE_OF_MERCURY]: 'mmHg',
  [EUnitOfMeasurement.MILLIMETRE_OF_WATER_COLUMN]: 'mmH₂O',
  [EUnitOfMeasurement.MILLIMETRE_PER_SECOND]: 'mm/s',
  [EUnitOfMeasurement.MILLITORR_PER_HOUR]: 'mTorr/h',
  [EUnitOfMeasurement.MILLIVOLT]: 'mV',
  [EUnitOfMeasurement.MILLI_AMPERE]: 'mA',
  [EUnitOfMeasurement.NEWTON_PER_SQUARE_MILLIMETRE]: 'N/mm²',
  [EUnitOfMeasurement.NORMAL_LITRE_PER_SQUARE_METERS_PER_HOUR]: 'nl/m²/h',
  [EUnitOfMeasurement.NUMBER]: '',
  [EUnitOfMeasurement.PARTS_PER_MILLION]: 'ppm',
  [EUnitOfMeasurement.PASCAL]: 'Pa',
  [EUnitOfMeasurement.PERCENT]: '%',
  [EUnitOfMeasurement.PERCENT_CARBON]: '%C',
  [EUnitOfMeasurement.PERCENT_HYDROGEN]: '%H',
  [EUnitOfMeasurement.PERCENT_NITROGEN]: '%N',
  [EUnitOfMeasurement.POUND]: 'lb',
  [EUnitOfMeasurement.PSI]: 'psi',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS]: 'HR',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_15_N]: 'HR 15 N',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_15_T]: 'HR 15 T',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_15_W]: 'HR 15 W',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_15_X]: 'HR 15 X',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_15_Y]: 'HR 15 Y',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_30_N]: 'HR 30 N',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_30_T]: 'HR 30 T',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_30_W]: 'HR 30 W',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_30_X]: 'HR 30 X',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_30_Y]: 'HR 30 Y',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_45_N]: 'HR 45 N',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_45_T]: 'HR 45 T',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_45_W]: 'HR 45 W',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_45_X]: 'HR 45 X',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_45_Y]: 'HR 45 Y',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_A]: 'HRA',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_B]: 'HRB',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_C]: 'HRC',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_D]: 'HRD',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_E]: 'HRE',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_F]: 'HRF',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_G]: 'HRG',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_H]: 'HRH',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_K]: 'HRK',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_L]: 'HRL',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_M]: 'HRM',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_P]: 'HRP',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_R]: 'HRR',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_S]: 'HRS',
  [EUnitOfMeasurement.ROCKWELL_HARDNESS_V]: 'HRV',
  [EUnitOfMeasurement.RPM]: '1/min',
  [EUnitOfMeasurement.SECOND]: 's',
  [EUnitOfMeasurement.THOUSANDTHS_OF_AN_INCH]: 'thou',
  [EUnitOfMeasurement.THOUSANDTHS_OF_MERCURY_COLUMN]: 'thou in Hg',
  [EUnitOfMeasurement.THOUSANDTHS_OF_WATER_COLUMN]: 'thou inH₂O',
  [EUnitOfMeasurement.TONNE]: 't',
  [EUnitOfMeasurement.TORR]: 'Torr',
  [EUnitOfMeasurement.TORR_PER_MINUTE]: 'Torr/min',
  [EUnitOfMeasurement.UNIT_LESS]: ' ', // Chart.js breaks signals with measurementId = 0 because yAxisID is an empty string
  [EUnitOfMeasurement.VICKERS_HARDNESS]: 'HV',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_1]: 'HV/0.1',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_2]: 'HV/0.2',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_3]: 'HV/0.3',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_4]: 'HV/0.4',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_5]: 'HV/0.5',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_6]: 'HV/0.6',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_7]: 'HV/0.7',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_8]: 'HV/0.8',
  [EUnitOfMeasurement.VICKERS_HARDNESS_0_9]: 'HV/0.9',
  [EUnitOfMeasurement.VICKERS_HARDNESS_100]: 'HV/100',
  [EUnitOfMeasurement.VICKERS_HARDNESS_10]: 'HV/10',
  [EUnitOfMeasurement.VICKERS_HARDNESS_1]: 'HV/1',
  [EUnitOfMeasurement.VICKERS_HARDNESS_20]: 'HV/20',
  [EUnitOfMeasurement.VICKERS_HARDNESS_2]: 'HV/2',
  [EUnitOfMeasurement.VICKERS_HARDNESS_30]: 'HV/30',
  [EUnitOfMeasurement.VICKERS_HARDNESS_40]: 'HV/40',
  [EUnitOfMeasurement.VICKERS_HARDNESS_50]: 'HV/50',
  [EUnitOfMeasurement.VICKERS_HARDNESS_5]: 'HV/5',
  [EUnitOfMeasurement.VICKERS_HARDNESS_60]: 'HV/60',
  [EUnitOfMeasurement.VICKERS_HARDNESS_70]: 'HV/70',
  [EUnitOfMeasurement.VICKERS_HARDNESS_80]: 'HV/80',
  [EUnitOfMeasurement.VICKERS_HARDNESS_90]: 'HV/90',
  [EUnitOfMeasurement.VOLT]: 'V',
  [EUnitOfMeasurement.VOLT_AMPERE]: 'VA',
  [EUnitOfMeasurement.WATT]: 'W',
  [EUnitOfMeasurement.WEIGHT_PERCENT]: 'wt%',
};

export default {
  AppGroupCommercial,
  UnitOfMeasurementSymbol,
  dataSourceName: {
    pt9800: 'Protherm Controller',
    nitrex_plant_manager: 'Nitride Controller',
    signal_builder: 'Signal Builder',
    job_feature: 'Job Feature',
  },
};
